module.exports = __webpack_public_path__ + "static/media/wizard_image.4a22955d.jpeg";